/**
 * Created by rhinov15 on 04/01/2016.
 */

import { Events, eventsManager } from "@rhinov/savane-js";

/**
 * Graphical node for representing junction point when selected or hovered
 *
 */
declare var cc: any;


export class JunctionPointNode extends cc.Sprite {

    constructor(_movable: boolean) {
        super();
        // Load sprite image texture
        this.initWithSpriteFrameName('plan/corner_hilighted.png');
    }

    /**
     * Remove listener added for zoomUpdate
     */
    removeListener () {
        eventsManager.instance.removeListener(this.scrollListener);
    }

    // Object creation, add a listener listening to zoom and scroll change
    onEnter () {
        // Call parent class
        super.onEnter();
        // Creat listener listening to zoom and scroll events
        this.scrollListener = eventsManager.instance.addListener(Events.ZOOM_SCROLLWIN_CHANGED, (_event: any) => {
            // Get the zoom and cap it minimu to 0.5
            var zoom = _event.getUserData();
            zoom = zoom < 0.5 ? 0.5 : zoom;
            // Then set node scale
            this.setScale(0.7 / Math.sqrt(zoom));
        });
    }

    // Object destruction, release the listener created
    onExit () {
        super.onExit();
        this.removeListener();
    }
}
